import { render, staticRenderFns } from "./InvoiceDiscountFormatForm.vue?vue&type=template&id=5d297870&"
import script from "./InvoiceDiscountFormatForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceDiscountFormatForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDiscountFormatForm.vue?vue&type=style&index=0&id=5d297870&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports